export { WebVitals } from './web-vitals';